export default __webpack_public_path__ + "assets/368a03dcf358664966188e170251e2e5.jpg";